import React, { useEffect, useMemo, useState } from 'react';
import { ActivityIndicator, Dimensions, Platform, ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import { ModalAlignmentEnum } from '@voltmoney/types';
import { isMobile, isMobileView } from '../../stack/utils';
import { getScreenType } from '../bankSelectPage/BankSelect';
import { Header } from "../../header/Header";
import { AspectRatioToken, BorderRadiusTokens, ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Button } from "../../button/Button";
import LottieView from "lottie-react-native";
import BottomSheet from "../BottomSheet";
import { Image } from "../../image/Image";
import { Divider } from "../../divider/Divider";
import { Icon } from "../../icon/Icon";
import { Space } from "../../space/Space";
import NeedHelpDC from "../NeedHelpDC";
import ThemeProvider from '@voltmoney/theme';
import BottomSheetMf, { BottomSheetAnimation } from '../../bottomSheetMF/bottomSheetMf';
const KycPhotoInit = ({ height, takePhotoAction, triggerAction, stepperData, goBackAction, loading, isImageUploaded, previewImage, takePhotoAgainAction, finalPhotoVerifyAction, kycPhotoUploadSuccess, continueToNextStepAction, needHelpAction, isFromJupiter, contactUsDetails, errorTitle, errorMessage, rejectedPhotoAction, showPhotoVerificationErrorCard, counter, onModalCloseAction, context, onClickShareLink, onClickShareLinkLoading, shareWhatsapplink, copyLinkToClipboard, shareLinkUrl, showPartnerView = true }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const [showRejectedCard, setShowRejectedCard] = useState(false);
    const [successLottie, setSuccessLottie] = useState('');
    const [isLottieFetched, setLottieFetched] = useState(false);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [_showPartnerView, setShowPartnerView] = useState(showPartnerView);
    const [showShareModal, setShowShareModal] = useState(false);
    const [shareLinkLoading, setShareLinkLoading] = useState(false);
    const [copied, setCopied] = useState(false);
    const [whatsappLoading, setWhatsappLoading] = useState(false);
    const [copyLoading, setCopyLoading] = useState(false);
    useEffect(() => {
        if (copied) {
            setTimeout(() => {
                setCopied(false);
            }, 3000);
        }
    }, [copied]);
    const isContextPartner = context === 'PARTNER';
    const successJsonLottie = "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json";
    useEffect(() => {
        if (showPhotoVerificationErrorCard) {
            setShowRejectedCard(showPhotoVerificationErrorCard);
        }
        else {
            setShowRejectedCard(false);
        }
    }, [showPhotoVerificationErrorCard, counter]);
    useEffect(() => {
        setShareLinkLoading(onClickShareLinkLoading);
    }, [onClickShareLinkLoading]);
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null
    };
    useEffect(() => {
        fetch(successJsonLottie, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            setSuccessLottie(responseData);
            setLottieFetched(true);
        })
            .catch((error) => {
            console.log(error);
        });
        if (showPartnerView === true && isContextPartner) {
            setShowPartnerView(true);
        }
        else {
            setShowPartnerView(false);
        }
    }, []);
    const _headerChild = useMemo(() => {
        return (React.createElement(Header, { id: "bt_uploadSelfie_goBack", type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, needHelpIcon: true, needHelpAction: () => setShowNeedHelp(true), isFromJupiter: isFromJupiter, title: "Upload selfie", onPress: () => {
                if (isContextPartner && !_showPartnerView) {
                    setShowPartnerView(true);
                }
                else {
                    triggerAction({
                        ...goBackAction
                    });
                }
            } }));
    }, [isContextPartner, _showPartnerView, goBackAction, stepperProps]);
    const renderLogo = useMemo(() => (React.createElement(React.Fragment, null,
        React.createElement(Image, { aspectRatio: AspectRatioToken.A1_1, borderRadius: BorderRadiusTokens.BR5, size: ImageSizeTokens.SIZE_64, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/kyc_camera.png' }))), []);
    const renderPhotoStatusCard = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: 260, width: '100%', closeFunction: () => {
                    onModalCloseAction &&
                        triggerAction(onModalCloseAction);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: false, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Platform.OS !== 'ios'
                        ? Dimensions.get('window').height + 10
                        : Dimensions.get('window').height
                    : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 508, routeId: 'routeId', handleKeyboard: true }, isLottieFetched &&
                renderVerificationSuccess())));
    };
    const renderPhotoRejectedCard = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: isMobileView() ? 280 : 260, width: '100%', closeFunction: () => {
                    onModalCloseAction &&
                        triggerAction(onModalCloseAction);
                    setShowRejectedCard(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Platform.OS !== 'ios'
                        ? Dimensions.get('window').height + 10
                        : Dimensions.get('window').height
                    : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 508, routeId: 'routeId', handleKeyboard: true }, renderPhotoRejectionCard())));
    };
    const renderPhotoRejectionCard = () => {
        return (React.createElement(TouchableOpacity, { style: styles.userCancelledCard, activeOpacity: 1 },
            React.createElement(Icon, { name: IconTokens.ErrorIcon, size: IconSizeTokens.Size56 }),
            React.createElement(View, { style: styles.title },
                React.createElement(Typography, { label: errorTitle, fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.subTitle },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: errorMessage, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { nativeID: 'bt_borrowerKyc_error', style: styles.errorButton },
                React.createElement(View, null,
                    React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Ok, got it', width: ButtonWidthTypeToken.FULL, onPress: () => {
                            rejectedPhotoAction &&
                                triggerAction(rejectedPhotoAction);
                            onModalCloseAction && triggerAction(onModalCloseAction);
                            setShowRejectedCard(false);
                        } })))));
    };
    const renderVerificationSuccess = () => {
        return (React.createElement(View, { style: styles.successCard },
            Platform.OS === 'ios' && (React.createElement(LottieView, { source: {
                    uri: 'https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json',
                }, style: { width: 70, height: 70 }, autoPlay: true, loop: true })),
            Platform.OS !== 'ios' &&
                successLottie !== '' && (React.createElement(LottieView, { source: successLottie, style: styles.successLottie, autoPlay: true, loop: true })),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: 'Selfie uploaded successfully!', fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'You will be redirected to next step in few seconds', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.successCTA },
                React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Continue', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        triggerAction({
                            ...continueToNextStepAction,
                        });
                    } }))));
    };
    const shareCard = () => (React.createElement(View, { style: { display: 'flex', flexDirection: 'column' } },
        React.createElement(View, { style: { height: 24 } }),
        React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: 'Share on WhatsApp', iconName: IconTokens.SYSTEM_WHATSAPP_DLS, loading: whatsappLoading, iconAlignment: 'left', onPress: async () => {
                await setWhatsappLoading(true);
                onClickShareLink &&
                    await triggerAction(onClickShareLink);
                await triggerAction(shareWhatsapplink);
                await setWhatsappLoading(false);
            } }),
        React.createElement(View, { style: { height: 16 } }),
        React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, label: copied ? 'Link copied' : 'Copy link', iconName: IconTokens.SYSTEM_COPY_DLS, loading: copyLoading, iconAlignment: 'left', onPress: async () => {
                await setCopyLoading(true);
                onClickShareLink &&
                    await triggerAction(onClickShareLink);
                await setCopied(true);
                await triggerAction(copyLinkToClipboard);
                await setCopyLoading(false);
            } })));
    const renderCard = ({ title, subtitle, iconName, loading = false, clickAction }) => {
        return (React.createElement(React.Fragment, null,
            React.createElement(TouchableOpacity, { style: { flex: 1 }, onPress: () => { clickAction(); } },
                React.createElement(View, { style: {
                        borderWidth: 1,
                        borderRadius: 12,
                        paddingHorizontal: 12,
                        paddingVertical: 16,
                        borderColor: colorMapping[ColorTokens.Grey_Chalk]
                    } },
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%'
                        } },
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                flex: 1,
                                paddingRight: 30
                            } },
                            React.createElement(View, { style: {
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: 10,
                                    borderRadius: 10,
                                    backgroundColor: colorMapping[ColorTokens.Primary_10],
                                    marginRight: 12
                                } },
                                React.createElement(Icon, { name: iconName, size: IconSizeTokens.SMALL_DLS })),
                            React.createElement(View, { style: { display: 'flex', flexDirection: 'column', flex: 1 } },
                                React.createElement(View, { style: { flex: 1 } },
                                    React.createElement(Typography, { label: title, color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B1S })),
                                React.createElement(View, { style: { height: 4 } }),
                                React.createElement(View, { style: { flex: 1 } },
                                    React.createElement(Typography, { label: subtitle, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal })))),
                        React.createElement(View, null, loading ?
                            React.createElement(ActivityIndicator, null) :
                            React.createElement(Icon, { name: IconTokens.RightArrow, size: IconSizeTokens.SMALL_DLS })))))));
    };
    const shareModal = () => {
        return (React.createElement(BottomSheetMf, { modalVisible: showShareModal, onModalClose: () => {
                setShowShareModal(false);
            }, animationType: BottomSheetAnimation.NONE, onModalOpen: () => setShowShareModal(true), showClose: true, onClosePress: () => {
            }, headerChild: React.createElement(React.Fragment, null,
                React.createElement(Typography, { label: 'Share link with customers', color: ColorTokens.Grey_Night, fontWeight: '600', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins })) }, shareCard()));
    };
    const renderPartnerShare = () => {
        return (React.createElement(View, { style: [
                styles.container,
                {
                    height: Platform.OS === 'ios'
                        ? height - 40
                        : height - 16,
                },
            ] },
            React.createElement(View, { style: styles.headerStyle }, _headerChild),
            React.createElement(View, { style: {
                    paddingHorizontal: 16,
                    marginTop: 24,
                } },
                renderLogo,
                React.createElement(View, { style: { marginTop: 4 } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Capture customer selfie ', fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24 }),
                        React.createElement(View, { style: { height: 4 } }),
                        React.createElement(Typography, { label: 'Take customer selfie for KYC. Refresh page after completion.', color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B1R }),
                        React.createElement(View, { style: { height: 32 } }),
                        renderCard({
                            title: 'Share link with customer',
                            subtitle: 'Customer will capture selfie on their device.',
                            iconName: IconTokens.SYSTEM_SHARE_DLS,
                            loading: shareLinkLoading,
                            clickAction: async () => {
                                // await triggerAction(onClickShareLink)
                                await setShowShareModal(true);
                            }
                        }),
                        React.createElement(View, { style: { height: 16 } }),
                        renderCard({
                            title: 'Capture on this device',
                            subtitle: 'Take a live photo of customer from this device.',
                            iconName: IconTokens.DEVICE_MOBILE,
                            loading: false,
                            clickAction: () => { setShowPartnerView(false); }
                        })))),
            shareModal(),
            showNeedHelp && (React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails }))));
    };
    return _showPartnerView
        ? renderPartnerShare()
        : (React.createElement(View, { style: [
                styles.container,
                {
                    height: Platform.OS === 'ios'
                        ? height - 40
                        : height,
                },
            ] },
            React.createElement(View, { style: styles.headerStyle }, _headerChild),
            !isImageUploaded ? (React.createElement(View, { style: {
                    paddingHorizontal: 16,
                    marginTop: 24,
                } },
                renderLogo,
                React.createElement(View, { style: { marginTop: 4 } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Capture selfie', fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24 }),
                        React.createElement(View, { style: {
                                backgroundColor: '#FFF6E3',
                                borderRadius: 8,
                                padding: 16,
                                marginTop: 12,
                            } },
                            React.createElement(Typography, { label: 'For faster approval', color: ColorTokens.Grey_Night, fontWeight: '500', lineHeight: 20, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM }),
                            React.createElement(View, { style: {
                                    marginTop: 8,
                                    flexDirection: 'row',
                                    marginLeft: 4,
                                } },
                                React.createElement(View, null,
                                    React.createElement(Typography, { label: `\u2022`, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontWeight: '400', lineHeight: 18, fontFamily: FontFamilyTokens.Inter })),
                                React.createElement(View, { style: { width: '95%', marginLeft: 4 } },
                                    React.createElement(Typography, { label: `Please remove your glasses and cap before capturing the photo`, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontWeight: '400', lineHeight: 18, fontFamily: FontFamilyTokens.Inter }))),
                            React.createElement(View, { style: {
                                    marginTop: 8,
                                    flexDirection: 'row',
                                    marginLeft: 4,
                                } },
                                React.createElement(View, null,
                                    React.createElement(Typography, { label: `\u2022`, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontWeight: '400', lineHeight: 18, fontFamily: FontFamilyTokens.Inter })),
                                React.createElement(View, { style: { width: '95%', marginLeft: 4 } },
                                    React.createElement(Typography, { label: `Make sure to take the photo in a well-lit area`, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontWeight: '400', lineHeight: 18, fontFamily: FontFamilyTokens.Inter })))))))) : (React.createElement(View, { style: {
                    paddingHorizontal: 16,
                    marginTop: 24,
                } },
                React.createElement(Typography, { label: 'Upload selfie', fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24 }),
                React.createElement(ScrollView, { style: {
                        paddingTop: 24,
                        flexDirection: 'column',
                        height: isImageUploaded
                            ? height - 240
                            : height - 240,
                    }, showsVerticalScrollIndicator: false, contentContainerStyle: {
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flexGrow: 1,
                    } },
                    React.createElement(View, { style: {
                            justifyContent: 'center',
                            alignContent: 'center',
                            alignSelf: 'center',
                            marginBottom: isImageUploaded ? 16 : 32,
                        } }, isImageUploaded && (React.createElement(View, null,
                        React.createElement(Image, { uri: `data:image/gif;base64,${previewImage}`, size: ImageSizeTokens.XXXXL, aspectRatio: AspectRatioToken.A1_1, borderRadius: BorderRadiusTokens.BR2 }),
                        React.createElement(Button, { id: 'bt_kycStepper_retakeSelfie', label: 'Retake', width: ButtonWidthTypeToken.FULL, type: ButtonTypeTokens.LargeGhost, onPress: () => {
                                triggerAction({
                                    ...takePhotoAgainAction,
                                });
                            } }))))))),
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    justifyContent: 'center',
                    width: '100%',
                    paddingBottom: 16,
                    backgroundColor: 'white',
                } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
                React.createElement(View, { style: {
                        alignItems: 'center',
                        alignContent: 'center',
                        paddingHorizontal: 16,
                        marginTop: 16,
                        alignSelf: 'center',
                        width: '100%',
                    } },
                    isImageUploaded && (React.createElement(View, { style: {
                            alignContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            marginBottom: 8,
                        } },
                        React.createElement(Icon, { name: IconTokens.Secure, size: IconSizeTokens.XS, color: ColorTokens.Secondary_100 }),
                        React.createElement(Space, { size: SizeTypeTokens.XS }),
                        React.createElement(Typography, { label: 'Your data is secure with us', fontSize: FontSizeTokens.XXS, fontWeight: '500', lineHeight: 16, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter }))),
                    React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: isImageUploaded
                            ? 'Upload selfie'
                            : 'Capture selfie', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, width: ButtonWidthTypeToken.FULL, loading: loading, height: 40, onPress: () => {
                            isImageUploaded
                                ? triggerAction({
                                    ...finalPhotoVerifyAction,
                                    payload: {
                                        base64Image: previewImage,
                                        ...finalPhotoVerifyAction.payload,
                                    },
                                })
                                : triggerAction({
                                    ...takePhotoAction,
                                });
                        } }),
                    isContextPartner &&
                        React.createElement(React.Fragment, null,
                            React.createElement(View, { style: { height: 16 } }),
                            React.createElement(TouchableOpacity, { style: {
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center'
                                }, onPress: async () => {
                                    // await triggerAction(onClickShareLink)
                                    await setShowShareModal(true);
                                } },
                                React.createElement(Typography, { label: 'Share link with customer', typeDLS: TypographyTypeDLS.B1B, color: ColorTokens.Primary_100 }),
                                onClickShareLinkLoading &&
                                    React.createElement(View, null,
                                        React.createElement(View, { style: { width: 8 } }),
                                        React.createElement(ActivityIndicator, null)))))),
            shareModal(),
            kycPhotoUploadSuccess &&
                renderPhotoStatusCard(),
            showNeedHelp && (React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails })),
            showRejectedCard && renderPhotoRejectedCard()));
};
const styles = StyleSheet.create({
    container: {},
    headerStyle: {
        ...(Platform.OS === 'ios' && {
            marginTop: 24,
        }),
    },
    contentContainer: {
        flex: 1,
        paddingHorizontal: 16,
        paddingBottom: 120,
    },
    successCard: {
        alignItems: 'center',
        flex: 1,
        height: 260,
        padding: 16,
    },
    successLottie: { width: 70, height: 'auto' },
    halfCardTitle: { marginTop: 16 },
    halfCardDescription: { marginTop: 4 },
    successCTA: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        paddingHorizontal: 16,
        marginBottom: 16,
        marginTop: 24,
    },
    failureCard: {
        alignItems: 'center',
        flex: 1,
        height: 270,
        padding: 16,
        justifyContent: 'space-between',
    },
    userCancelledCard: {
        alignItems: 'center',
        padding: 16,
        // zIndex: 2,
        ...(Platform.OS !== 'ios' && {
            flex: 1,
        }),
    },
    title: {
        marginTop: 16,
    },
    subTitle: {
        marginTop: 8,
        padding: 8,
        marginBottom: 8,
        paddingHorizontal: 16,
        borderRadius: 8,
        backgroundColor: '#FEF4E6',
        width: '100%',
        marginHorizontal: 16,
        flexShrink: 1,
    },
    errorButton: {
        width: '100%',
        marginTop: 16,
        // paddingHorizontal: 16,
        // paddingBottom: 8,
        // marginBottom: 4
    },
});
export default KycPhotoInit;
